<template>
  <div class="flex h-full w-full flex-col">
    <keep-alive>
      <marker-panel v-if="isMarkerPanelOpen" v-model="currentMarkerPanelTab" @close="closeRightPanel" />
    </keep-alive>
    <keep-alive>
      <embed-format-panel v-if="isFormatPanelOpen" v-model="currentFormatPanelTab" @close="closeRightPanel" />
    </keep-alive>
  </div>
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent } from 'vue'
import PlaceholderPanel from 'client/pages/app/fragments/shared/placeholder-panel.vue'
import { useEditorPanelManage } from 'app/composables/use-editor-panel-manage'

const MarkerPanel = defineAsyncComponent({
  loader: () => import('client/pages/app/fragments/shared/editor-right-panel/marker-panel/marker-panel.vue'),
  loadingComponent: PlaceholderPanel,
})

const EmbedFormatPanel = defineAsyncComponent({
  loader: () => import('./embed-format-panel.vue'),
  loadingComponent: PlaceholderPanel,
})

const { currentRightPanelTab, currentFormatPanelTab, currentMarkerPanelTab, closeRightPanel } = useEditorPanelManage()
const isFormatPanelOpen = computed(() => currentRightPanelTab.value === 'STYLE')
const isMarkerPanelOpen = computed(() => currentRightPanelTab.value === 'MARKER')
</script>
